import { getPriceEdoc } from '@/api/pc-api/v2/{authInfoId}/price/edoc';
import { getPriceEproof } from '@/api/pc-api/v2/{authInfoId}/price/eproof';
import { getPriceMydata } from '@/api/pc-api/v2/{authInfoId}/price/mydata';
import { getPriceSet4 } from '@/api/pc-api/v2/{authInfoId}/price/set4';
import { BizType } from '@/constants/bizType';

export const getPrice = (targetId: string, bizType: BizType) => {
  switch (bizType) {
    case BizType.SET4:
      return getPriceSet4(targetId);
    case BizType.EDOC:
      return getPriceEdoc(targetId);
    case BizType.EPROOF:
      return getPriceEproof(targetId);
    default:
      return getPriceMydata(targetId);
  }
};
